/**
 * Who else has this board open, in this browser, right now.
 *
 * Cursor positions are ephemeral: never persisted, never merged into the scene,
 * and dropped when a peer goes quiet.
 */

export interface Peer {
  readonly clientId: string;
  readonly x: number;
  readonly y: number;
  readonly color: string;
  readonly lastSeen: number;
}

/** A peer is forgotten after this long without a message. */
export const PEER_TIMEOUT_MS = 6000;
export const CURSOR_THROTTLE_MS = 60;

const PEER_COLORS = ['#1570ef', '#027a48', '#b54708', '#6941c6', '#b42318', '#0e7090'];

export function colorForClient(clientId: string): string {
  let hash = 0;
  for (let i = 0; i < clientId.length; i++) hash = (hash * 31 + clientId.charCodeAt(i)) | 0;
  return PEER_COLORS[Math.abs(hash) % PEER_COLORS.length]!;
}

export function upsertPeer(
  peers: readonly Peer[],
  clientId: string,
  x: number,
  y: number,
  now: number,
): Peer[] {
  const next = peers.filter((p) => p.clientId !== clientId && now - p.lastSeen < PEER_TIMEOUT_MS);
  next.push({ clientId, x, y, color: colorForClient(clientId), lastSeen: now });
  return next;
}

export function prunePeers(peers: readonly Peer[], now: number): Peer[] {
  return peers.filter((p) => now - p.lastSeen < PEER_TIMEOUT_MS);
}

export function removePeer(peers: readonly Peer[], clientId: string): Peer[] {
  return peers.filter((p) => p.clientId !== clientId);
}
